export interface IChargeCategory {
    id: string;
    updated_at: string;
    created_at: string;
    updated_by: any;
    created_by: any;
    is_active: boolean;
    charge_category_name: string;
    description: string;
    company: string;
}

export interface IChargeCategoryError {
    id: string[];
    updated_at: string[];
    created_at: string[];
    is_active: string[];
    charge_category_name: string[];
    description: string[];
    company: string[];
}

export class ChargeCategoryModel implements IChargeCategory {
    id: string;
    updated_at: string;
    created_at: string;
    updated_by: any;
    created_by: any;
    is_active: boolean;
    charge_category_name: string;
    description: string;
    company: string;

    error: IChargeCategoryError;

    constructor() {
        this.id = null;
        this.updated_at = null;
        this.created_at = null;
        this.updated_by = null;
        this.created_by = null;
        this.is_active = true;
        this.charge_category_name = null;
        this.description = null;
        this.company = null;

        this.resetError();
    }

    resetError() {
        this.error = {
            id: [],
            updated_at: [],
            created_at: [],
            is_active: [],
            charge_category_name: [],
            description: [],
            company: [],
        }
    }

    patchToModel(data) {
        this.id = data != null && data.id ? data.id : null;
        this.updated_at = data != null && data.updated_at ? data.updated_at : null;
        this.created_at = data != null && data.created_at ? data.created_at : null;
        this.updated_by = data != null && data.updated_by ? data.updated_by : null;
        this.created_by = data != null && data.created_by ? data.created_by : null;
        this.is_active = data != null && data.is_active ? data.is_active : true;
        this.charge_category_name = data != null && data.charge_category_name ? data.charge_category_name : null;
        this.description = data != null && data.description ? data.description : null;
        this.company = data != null && data.company ? data.company : null;
    }

    getPayload() {
        return {
            is_active: this.is_active,
            charge_category_name: this.charge_category_name,
            description: this.description,
        }
    }

    checkChargeCategoryErrors() {
        return this.error.charge_category_name.length == 0
            && this.error.description.length == 0
    }

    mapChargeCategoryErrors(err) {
        this.error.charge_category_name = err.charge_category_name?.length ? err.charge_category_name : [];
        this.error.description = err.description?.length ? err.description : [];
    }
}